import React from "react";
import { Controller, Control } from "react-hook-form";
import {
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  FormControl,
} from "@mui/material";

type RHFCheckboxProps = {
  name: string;
  label: string;
  control: Control<any>;
  inputProps?: CheckboxProps["inputProps"];
} & Omit<CheckboxProps, "name" | "checked" | "onChange" | "value">;

export const RHFCheckbox: React.FC<RHFCheckboxProps> = ({
  name,
  label,
  control,
  inputProps,
  ...other
}) => {
  return (
    <FormControl>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <FormControlLabel
            control={
              <Checkbox
                checked={!!field.value}
                inputProps={inputProps}
                onChange={(e) => field.onChange(e.target.checked)}
                {...other}
              />
            }
            label={label}
          />
        )}
      />
    </FormControl>
  );
};
